import { observer } from 'mobx-react-lite';
import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import { PersonalInfo } from '~/views/organisms/personal.info';
import { PurchaseHistory } from '~/views/organisms/purchase.history';
import { BackBtn } from '~/views/atoms/back.btn';
import { AccountMenu } from '~/views/molecules/account.menu';
import { AccountMenuItem } from '~/views/enums';

export const PageAccount: FC = observer(() => {
    const location = useLocation();
    const menuItem = useMemo(() => {
        let accountMenuItem: AccountMenuItem = AccountMenuItem.personalInfo;
        switch (location.pathname) {
            case ROUTES.PERSONAL_INFO.path:
                accountMenuItem = AccountMenuItem.personalInfo;
                break;
            case ROUTES.ACCOUNT_PAYMENTS.path:
                accountMenuItem = AccountMenuItem.payments;
                break;
            case ROUTES.PURCHASE_HISTORY.path:
                accountMenuItem = AccountMenuItem.purchaseHistory;
                break;
            default:
                accountMenuItem = AccountMenuItem.personalInfo;
                break;
        }
        return accountMenuItem;
    }, [location.pathname]);

    return (
        <div className="container">
            <BackBtn path={ROUTES.MAIN.path} />
            <div className="account-wrap">
                <AccountMenu activeItem={menuItem} />
                {menuItem === AccountMenuItem.personalInfo ? <PersonalInfo /> : null}
                {menuItem === AccountMenuItem.purchaseHistory ? <PurchaseHistory /> : null}
            </div>
        </div>
    );
});
